export default "__VITE_ASSET__dbc4da58__"